import * as API from "@/services/API";

export default {
  newsletterForm(payload) {
    return new Promise((resolve, reject) => {
      API.apiClient
        .post("/subscribe", payload)
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};
